module.exports = __webpack_public_path__ + "img/equipment.925e2710.svg";